import {
  GroupLocator,
  TeamsMeetingLinkLocator,
} from "@azure/communication-calling"

export const navigateToHomePage = (): void => {
  window.location.href = window.location.href.split("?")[0]
}

export const getGroupIdFromUrl = (): GroupLocator | undefined => {
  const urlParams = new URLSearchParams(window.location.search)
  const gid = urlParams.get("groupId")
  return gid ? { groupId: gid } : undefined
}

export const getTeamsLinkFromUrl = (): TeamsMeetingLinkLocator | undefined => {
  const urlParams = new URLSearchParams(window.location.search)
  const teamsLink = urlParams.get("teamsLink")
  return teamsLink ? { meetingLink: teamsLink } : undefined
}